import ReactOnRails from 'react-on-rails';

import AddPaymentRouter from '@javascript/vehicle_enquiry/add_payment/addPaymentRouter';
import CancelledPaymentVehicle from '@javascript/vehicle_enquiry/cancelledPaymentVehicle';
import CashPrice from '@components/application/pricing/cashPrice';
import ContinueSearchButton from '@javascript/vehicle_enquiry/continueSearchButton';
import ReservationHeader from '@javascript/vehicle_enquiry/reservationHeader';
import ReserveNowRouter from '@javascript/vehicle_enquiry/reserve_now/reserveNowRouter';
import Saving from '@components/application/pricing/saving';
import VehicleEnquiryRouter from '@javascript/vehicle_enquiry/vehicle_enquiry/vehicleEnquiryRouter';

ReactOnRails.register({
  AddPaymentRouter,
  CancelledPaymentVehicle,
  CashPrice,
  ContinueSearchButton,
  ReservationHeader,
  ReserveNowRouter,
  Saving,
  VehicleEnquiryRouter,
});
